/* Product page — gallery thumbnails, variant price/availability, quantity. ~1KB */
(function () {
  document.querySelectorAll('.pd').forEach(function (pd) {
    /* ---- Gallery ---- */
    var main = pd.querySelector('[data-gallery]');
    var gPrev = pd.querySelector('[data-gallery-prev]');
    var gNext = pd.querySelector('[data-gallery-next]');
    if (main && gPrev) gPrev.addEventListener('click', function () { main.scrollBy({ left: -main.clientWidth, behavior: 'smooth' }); });
    if (main && gNext) gNext.addEventListener('click', function () { main.scrollBy({ left: main.clientWidth, behavior: 'smooth' }); });
    var thumbs = Array.prototype.slice.call(pd.querySelectorAll('[data-gallery-thumb]'));
    if (main && thumbs.length) {
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { main.scrollTo({ left: i * main.clientWidth, behavior: 'smooth' }); });
      });
      var raf;
      main.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var idx = Math.round(main.scrollLeft / main.clientWidth);
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
        });
      }, { passive: true });
    }

    /* ---- Variant ---- */
    var select = pd.querySelector('select[data-variant-select]');
    if (select) {
      var priceEl = pd.querySelector('[data-price-current]');
      var compareEl = pd.querySelector('[data-price-compare]');
      var saveEl = pd.querySelector('[data-price-save]');
      var addBtn = pd.querySelector('[data-add]');
      var addText = pd.querySelector('[data-add-text]');
      var addLabel = addText ? addText.textContent : '';
      var imgSave = pd.querySelector('[data-img-save]');
      var imgSoldout = pd.querySelector('[data-img-soldout]');
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        if (compareEl) {
          if (opt.dataset.compare) {
            compareEl.textContent = opt.dataset.compare; compareEl.hidden = false;
            if (saveEl) { if (opt.dataset.save) saveEl.textContent = '−' + opt.dataset.save + '% OFF'; saveEl.hidden = false; }
            if (imgSave) { if (opt.dataset.save) imgSave.innerHTML = '−' + opt.dataset.save + '%'; imgSave.hidden = false; }
          }
          else { compareEl.hidden = true; if (saveEl) saveEl.hidden = true; if (imgSave) imgSave.hidden = true; }
        }
        var available = opt.dataset.available === 'true';
        if (addBtn) addBtn.disabled = !available;
        if (addText) addText.textContent = available ? addLabel : 'Sold out';
        if (imgSoldout) imgSoldout.hidden = available;
      });
    }

    /* ---- Quantity ---- */
    var qty = pd.querySelector('input[name="quantity"]');
    if (qty) {
      var minus = pd.querySelector('[data-qty-minus]');
      var plus = pd.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }
  });
})();
